import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { SystemService } from '../../shared/system.service';

export const systemModuleAccessGuard: CanActivateFn = (route, state) => {
  const systemService = inject(SystemService);
  const router = inject(Router);
  return isModuleEnabled(systemService, state.url, router);
};

function isModuleEnabled(systemService: SystemService, url: string, router: Router): Observable<boolean | UrlTree> {
  return systemService.getSystemState().pipe(
    switchMap(systemConfigState => {
      if (
        (url === '/planner' && systemConfigState?.plannerEnabled) ||
        (url === '/ordermanagement' && systemConfigState?.orderManagementStatus) ||
        (url === '/elearning' && systemConfigState?.eLearningEnabled) ||
        (url === '/elearning/information-center' && systemConfigState?.eLearningEnabled) ||
        (url === '/my-elearning' && systemConfigState?.eLearningEnabled) ||
        (url.startsWith('/tpm') && systemConfigState?.tpmEnabled) ||
        (url === '/survey' && systemConfigState?.surveyEnabled) ||
        (url === '/survey-analytics' && systemConfigState?.surveyEnabled) ||
        (url === '/my-survey' && systemConfigState?.surveyEnabled) ||
        (url === '/my-reviews' && systemConfigState?.surveyEnabled) ||
        (url === '/my-confirmations' && systemConfigState?.createTrainingChecklist)
      ) {
        return of(true);
      } else {
        return of(router.createUrlTree(['/404']));
      }
    })
  );
}
